<template>
  <b-row class="time-row">
    <template v-if="!isUnassigneduser(user)">
      <b-col md="6">
        Last week: <br />{{ getLogsForLastWeek(user) }}
        <span class="clock-custom">
          <b-icon-clock-history />
        </span>
      </b-col>
      <b-col md="6">
        Last day: <br />
        <span :class="getLastDayClass(getLogsForPreviousDay(user))">
          {{ getLogsForPreviousDay(user) }}
          <span class="clock-custom">
            <b-icon-clock-history />
          </span>
        </span>
      </b-col>
    </template>
    <div v-else class="no-time-log"></div>
  </b-row>
</template>

<script>
import momentBusiness from "moment-business-days"

export default {
  name: "TimeRow",
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  methods: {
    /**
     * Gets class based on whether or not the user has 'underlogged'
     * @param timeLogged
     * @returns {{underlogged: boolean}}
     */
    getLastDayClass(timeLogged) {
      return { underlogged: timeLogged < 5 }
    },
    /**
     * Gets user time logged for past 5 business days
     * @param user
     * @returns {string|number}
     */
    getLogsForLastWeek(user) {
      let timeArray = user.recentTimeLogs?.filter(x =>
        momentBusiness(new Date(x.date), "YYYY-DD-MM").isBetween(
          momentBusiness(new Date(), "YYYY-DD-MM").businessAdd(-6),
          momentBusiness(new Date(), "YYYY-DD-MM").prevBusinessDay()
        )
      )

      timeArray = timeArray?.map(x => x.time) ?? []
      if (!timeArray.length) return 0
      let time =
        timeArray.reduce(
          (accumulator, currentValue) => accumulator + currentValue
        ) ?? 0

      return time.toFixed(2)
    },
    /**
     * Gets user time logged for last business day
     * @param user
     * @returns {string|number}
     */
    getLogsForPreviousDay(user) {
      const timeArray =
        user.recentTimeLogs
          ?.filter(x =>
            momentBusiness(new Date(x.date), "YYYY-DD-MM").isSame(
              momentBusiness(new Date(), "YYYY-DD-MM").prevBusinessDay(),
              "day"
            )
          )
          ?.map(x => x.time) ?? []
      if (!timeArray.length) return 0
      let time =
        timeArray.reduce(
          (accumulator, currentValue) => accumulator + currentValue
        ) ?? 0
      return time.toFixed(2)
    },

    /**
     * Checks if this user is the 'Unassigned' user
     * @param user
     * @returns {*}
     */
    isUnassigneduser(user) {
      return user.id.includes("**Unassigned**")
    }
  }
}
</script>

<style scoped>
.time-row {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.clock-custom {
  vertical-align: text-bottom;
}

@media (min-width: 1500px) {
  .no-time-log {
    margin: 1.6rem !important;
  }
}
.no-time-log {
  margin: 1.3rem;
}
.underlogged {
  font-weight: bold;
  color: red;
}
</style>
